/**
 * Lenis smooth scroll — 1200px 以上のみ有効
 */
(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 1200px)');
  const REDUCED_MOTION_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** @type {InstanceType<typeof Lenis> | null} */
  let lenis = null;

  function shouldEnable() {
    return DESKTOP_MQ.matches && !REDUCED_MOTION_MQ.matches;
  }

  function enableLenis() {
    if (lenis || typeof Lenis === 'undefined') return;

    lenis = new Lenis({
      autoRaf: true,
      lerp: 0.1,
      smoothWheel: true,
    });

    document.documentElement.classList.add('tata-lenis-active');
  }

  function disableLenis() {
    if (!lenis) return;

    lenis.destroy();
    lenis = null;
    document.documentElement.classList.remove('tata-lenis-active');
  }

  /** @param {boolean} stopped */
  function setLenisStopped(stopped) {
    if (!lenis) return;
    if (stopped) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }

  window.tataLenisControl = {
    stop: () => setLenisStopped(true),
    start: () => setLenisStopped(false),
  };

  function syncLenis() {
    if (shouldEnable()) {
      enableLenis();
    } else {
      disableLenis();
    }
  }

  function onMediaChange() {
    syncLenis();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncLenis, { once: true });
  } else {
    syncLenis();
  }

  DESKTOP_MQ.addEventListener('change', onMediaChange);
  REDUCED_MOTION_MQ.addEventListener('change', onMediaChange);

  window.addEventListener('pagehide', disableLenis);
})();
